// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.assign-role-container {
  display: flex;
  flex-direction: column;
  min-height: 88vh;
}
.assign-role-container h1 {
  padding-left: 20px;
}
.assign-role-container .btn-create-user-holder {
  display: flex;
  margin-left: auto;
  padding: 0 20px;
}
.assign-role-container .btn-create-user {
  height: 37px;
  width: 130px;
  margin-left: 89%;
}
.assign-role-container .assign-role-content-container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 97%;
  margin-left: 1.5%;
  background-color: var(--content-container-background);
  border-radius: 10px;
}
.assign-role-container .assign-role-content-container .assign-role-title-container .assign-role-title {
  font-size: 14px;
  font-weight: 500;
  background-color: var(--table-background-color);
  margin: 2px;
  padding: 4px 10px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
}
.assign-role-container .assign-role-content-container .assign-action-buttons {
  display: flex;
  flex-direction: row;
  margin-right: 20px;
  margin-bottom: 20px;
  gap: 15px;
  justify-content: flex-end;
}
.assign-role-container .assign-role-content-container .input-container {
  width: 88vw;
  min-height: 360px;
  padding-bottom: 45px;
  background-color: var(--content-container-background);
  display: flex;
  flex-grow: 1;
}
.assign-role-container .assign-role-content-container .input-container .lhs-input-column-one {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.assign-role-container .assign-role-content-container .input-container .lhs-input-column-one .wrapper {
  position: absolute;
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid var(--input-field-border-color);
  border-radius: 4px;
  background-color: var(--input-field-color);
  color: var(--input-text-color);
  font-size: 12px;
  font-family: Arial;
  z-index: 0;
}
.assign-role-container .assign-role-content-container .input-container .lhs-input-column-one .wrapper .dYrfwz {
  padding-left: 8px;
  min-height: 32px;
  width: 100%;
  display: flex;
  align-items: center;
}
.assign-role-container .assign-role-content-container .input-container .lhs-input-column-one .wrapper:focus {
  outline: none;
  border-color: none;
}
.assign-role-container .assign-role-content-container .input-container .lhs-input-column-one .input-field {
  padding: 12px;
  align-items: center;
  gap: 8px;
  flex: 1 0;
  width: 372px;
  height: 13px;
  border-radius: 6px;
  gap: 4px;
  border: 1px solid #dbdbdb;
  margin-bottom: 6px;
  margin-top: 4px;
}
.assign-role-container .assign-role-content-container .input-container .lhs-input-column-one .input-field:focus {
  outline: none;
  border-color: none;
}
.assign-role-container .assign-role-content-container .input-container .rhs-text-area-container-and-btn-group {
  display: flex;
  flex-direction: column;
  margin-right: 30px;
  gap: 2px;
  margin-top: 70px;
}
.assign-role-container .assign-role-content-container .input-container .rhs-text-area-container-and-btn-group .application {
  margin-top: 33px;
}
.assign-role-container .assign-role-content-container .input-container .rhs-text-area-container-and-btn-group .input-field {
  padding: 12px;
  align-items: center;
  gap: 8px;
  flex: 1 0;
  width: 372px;
  height: 13px;
  border-radius: 6px;
  gap: 4px;
  border: 1px solid #cacaca;
  margin-bottom: 6px;
  margin-top: 4px;
}
.assign-role-container .assign-role-content-container .input-container .rhs-text-area-container-and-btn-group .input-field:focus {
  outline: none;
  border-color: #2a35ff;
}
.assign-role-container .assign-role-content-container .input-container .userNotFound {
  display: block;
  color: red;
}
.assign-role-container .assign-role-content-container .input-container .userFound {
  display: none;
}
.assign-role-container .assign-role-content-container .input-container label {
  color: var(--label-color);
  font-family: ABBvoice-Regular;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  margin-bottom: 2px;
}
.assign-role-container .assign-role-content-container .input-container .select {
  display: flex;
  padding: 10px;
  align-items: center;
  gap: 8px;
  flex: 1 0;
  width: 400px;
  height: 41px;
  border: 1px solid #cacaca;
  border-radius: 5px;
  font-size: 14px;
}
.assign-role-container .assign-role-content-container .input-container .select option {
  display: flex;
  height: 16px;
  flex-direction: column;
  justify-content: center;
  flex: 1 0;
  overflow: auto;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: ABBvoice;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 115%;
}
.assign-role-container .assign-role-content-container .input-container .select:focus {
  border: 1px solid #36f;
}
.assign-role-container .assign-role-content-container .input-container .select::selection {
  border: 1px solid #36f;
}
.assign-role-container .assign-role-content-container .input-container .lhs-input-column-one {
  margin: 31px 31px 31px 18px;
  min-width: 25vw;
  display: flex;
  justify-content: flex-start;
  gap: 10px;
}
.assign-role-container .assign-role-content-container .input-container .lhs-input-column-one .assign-role-input {
  display: flex;
  height: 34px;
}
.assign-role-container .assign-role-content-container .input-container .lhs-input-column-one .assign-role-input .autosearch {
  width: 240px;
  z-index: 10;
}
.assign-role-container .assign-role-content-container .input-container .lhs-input-column-one .assign-role-input .ABB_CommonUX_Dropdown__comp {
  width: 240px;
}
.assign-role-container .assign-role-content-container .input-container .lhs-input-column-one .assign-role-input label {
  display: flex;
  min-width: 114px;
  align-items: center;
}
.assign-role-container .assign-role-content-container .input-container .lhs-input-column-one .assign-role-input .css-15g569d-control {
  border: 1px solid var(--input-field-border-color) !important;
  background-color: var(--input-field-color) !important;
}
.assign-role-container .assign-role-content-container .input-container .lhs-input-column-one .role {
  margin-bottom: auto;
  margin-left: 1px;
}
.assign-role-container .assign-role-content-container .input-container .togged-roles {
  margin-top: 30px;
  margin-bottom: 10px;
}
.assign-role-container .assign-role-content-container .input-container .togged-roles .togged-role-text {
  color: #1f1f1f;
  font-family: "ABBvoice";
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  margin-bottom: 10px;
}
.assign-role-container .assign-role-content-container .input-container .togged-roles .card-container {
  display: flex;
  flex-wrap: wrap;
  overflow-y: auto;
  width: 54vw;
  flex-shrink: 0;
  margin-top: -14px;
  margin-left: -6px;
}
.assign-role-container .assign-role-content-container .input-container .togged-roles .card-container .role-card {
  font-family: "ABBvoice";
  background-color: #ebebeb;
  font-size: 14px;
  font-style: normal;
  height: fit-content;
  padding: 3px;
  margin: 10px 10px 10px 6px;
  padding-left: 10px;
  border-radius: 16px;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
}
.assign-role-container .assign-role-content-container .input-container .togged-roles .card-container .role-card span {
  margin-right: 5px;
  font-size: 12px;
}
.assign-role-container .assign-role-content-container .input-container .togged-roles .card-container .role-card button {
  background: none;
  border: none;
  cursor: pointer;
  margin-left: 5px;
}
.assign-role-container .assign-role-content-container .input-container .togged-user-new-roles {
  margin-top: 40px;
  margin-bottom: 10px;
}
.assign-role-container .assign-role-content-container .input-container .togged-user-new-roles .togged-role-text {
  color: #1f1f1f;
  font-family: "ABBvoice";
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  margin-bottom: 10px;
}
.assign-role-container .assign-role-content-container .input-container .togged-user-new-roles .card-container {
  display: flex;
  flex-wrap: wrap;
  overflow-y: auto;
  width: 54vw;
  flex-shrink: 0;
  margin-top: -14px;
  margin-left: -6px;
}
.assign-role-container .assign-role-content-container .input-container .togged-user-new-roles .card-container .role-card {
  font-family: "ABBvoice";
  background-color: #ebebeb;
  font-size: 14px;
  font-style: normal;
  height: fit-content;
  padding: 3px;
  margin: 10px 10px 10px 6px;
  padding-left: 10px;
  border-radius: 16px;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
}
.assign-role-container .assign-role-content-container .input-container .togged-user-new-roles .card-container .role-card span {
  margin-right: 5px;
  font-size: 12px;
}
.assign-role-container .assign-role-content-container .input-container .togged-user-new-roles .card-container .role-card button {
  background: none;
  border: none;
  cursor: pointer;
  margin-left: 5px;
}
.assign-role-container .assign-role-content-container .ABB_CommonUX_Button__root.ABB_CommonUX_Button__mediumSize > div > span.ABB_CommonUX_Button__icon,
.assign-role-container .assign-role-content-container .ABB_CommonUX_Button__root.ABB_CommonUX_Button__mediumSize > div > span.ABB_CommonUX_Button__loadingIndicator {
  height: 15px;
  left: 10px;
  top: 11px;
  width: 16px;
}
.assign-role-container .flex-justify-end {
  display: flex;
  justify-content: end;
  padding: 0px 20px 20px 0px;
}
.assign-role-container .jiMOeR .wrapper:focus-within {
  box-shadow: none !important;
}

.ABB_CommonUX_Input__root > .ABB_CommonUX_Input__inputWrapper {
  border-color: #dbdbdb !important;
  border-radius: 4px !important;
  border-width: 2px !important;
}

.css-15g569d-control {
  width: 100%;
  height: 34px !important;
  border: 2px solid #dbdbdb !important;
  border-radius: 4px !important;
}

.css-1xr93k-control {
  border-radius: 4px !important;
  border-color: none !important;
}

.css-1xr93k-control :hover {
  background: var(--dropdown-background-color-hover) !important;
}

.dYrfwz > input {
  width: 100%;
  padding: 0px 0px 0px 13px;
  border: none;
  outline: none;
  background-color: rgba(0, 0, 0, 0);
  font-size: 14px !important;
  font-family: "ABBvoice" !important;
  color: var(--input-text-color);
}

.gap-30 {
  gap: 30px !important;
}

.gap-20 {
  gap: 20px !important;
}

.gap-40 {
  gap: 40px !important;
}

.css-ht7ws5 {
  color: var(--input-text-color) !important;
  height: 16px;
  line-height: 16px;
  width: 0;
  margin-top: 1px;
  grid-row: 1;
  grid-column: 1;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/assign_role.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AACF;AAAE;EACE,kBAAA;AAEJ;AAAE;EACE,aAAA;EACA,iBAAA;EACA,eAAA;AAEJ;AACE;EACE,YAAA;EACA,YAAA;EACA,gBAAA;AACJ;AACE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,UAAA;EACA,iBAAA;EACA,qDAAA;EACA,mBAAA;AACJ;AAEM;EACE,eAAA;EACA,gBAAA;EACA,+CAAA;EACA,WAAA;EACA,iBAAA;EACA,4BAAA;EACA,2BAAA;AAAR;AAGI;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;AADN;AAGI;EACE,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,qDAAA;EACA,aAAA;EACA,YAAA;AADN;AAEM;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;AAAR;AAEQ;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iDAAA;EACA,kBAAA;EACA,0CAAA;EACA,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;AAAV;AACU;EACE,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EAEA,mBAAA;AACZ;AAEQ;EACE,aAAA;EACA,kBAAA;AAAV;AAEQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AAAV;AAEQ;EACE,aAAA;EACA,kBAAA;AAAV;AAGM;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,gBAAA;AADR;AAEQ;EACE,gBAAA;AAAV;AAEQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AAAV;AAEQ;EACE,aAAA;EACA,qBAAA;AAAV;AAGM;EACE,cAAA;EACA,UAAA;AADR;AAGM;EACE,aAAA;AADR;AAGM;EACE,yBAAA;EACA,6BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AADR;AAGM;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AADR;AAEQ;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAAV;AAGM;EACE,sBAAA;AADR;AAGM;EACE,sBAAA;AADR;AAGM;EACE,2BAAA;EACA,eAAA;EACA,aAAA;EACA,2BAAA;EACA,SAAA;AADR;AAEQ;EACE,aAAA;EACA,YAAA;AAAV;AACU;EACE,YAAA;EACA,WAAA;AACZ;AACU;EACE,YAAA;AACZ;AACU;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;AACZ;AACU;EACE,4DAAA;EACA,qDAAA;AACZ;AAEQ;EACE,mBAAA;EACA,gBAAA;AAAV;AAGM;EACE,gBAAA;EACA,mBAAA;AADR;AAEQ;EACE,cAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAAV;AAEQ;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;AAAV;AACU;EACE,uBAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;AACZ;AAAY;EACE,iBAAA;EACA,eAAA;AAEd;AAAY;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAEd;AAGM;EACE,gBAAA;EACA,mBAAA;AADR;AAEQ;EACE,cAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAAV;AAEQ;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;AAAV;AACU;EACE,uBAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;AACZ;AAAY;EACE,iBAAA;EACA,eAAA;AAEd;AAAY;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAEd;AAII;;EAME,YAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;AANN;AASE;EACE,aAAA;EACA,oBAAA;EACA,0BAAA;AAPJ;AASE;EACE,2BAAA;AAPJ;;AAWA;EACE,gCAAA;EACA,6BAAA;EACA,4BAAA;AARF;;AAUA;EACE,WAAA;EACA,uBAAA;EACA,oCAAA;EACA,6BAAA;AAPF;;AASA;EACE,6BAAA;EACA,6BAAA;AANF;;AAQA;EACE,6DAAA;AALF;;AAOA;EACE,WAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,kCAAA;EACA,0BAAA;EACA,kCAAA;EACA,8BAAA;AAJF;;AAMA;EACE,oBAAA;AAHF;;AAKA;EACE,oBAAA;AAFF;;AAIA;EACE,oBAAA;AADF;;AAIA;EACE,yCAAA;EACA,YAAA;EACA,iBAAA;EACA,QAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;AADF","sourcesContent":[".assign-role-container {\n  display: flex;\n  flex-direction: column;\n  min-height: 88vh;\n  h1 {\n    padding-left: 20px;\n  }\n  .btn-create-user-holder {\n    display: flex;\n    margin-left: auto;\n    padding: 0 20px;\n  }\n\n  .btn-create-user {\n    height: 37px;\n    width: 130px;\n    margin-left: 89%;\n  }\n  .assign-role-content-container {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    width: 97%;\n    margin-left: 1.5%;\n    background-color: var(--content-container-background);\n    border-radius: 10px;\n\n    .assign-role-title-container {\n      .assign-role-title {\n        font-size: 14px;\n        font-weight: 500;\n        background-color: var(--table-background-color);\n        margin: 2px;\n        padding: 4px 10px;\n        border-top-right-radius: 8px;\n        border-top-left-radius: 8px;\n      }\n    }\n    .assign-action-buttons {\n      display: flex;\n      flex-direction: row;\n      margin-right: 20px;\n      margin-bottom: 20px;\n      gap: 15px;\n      justify-content: flex-end;\n    }\n    .input-container {\n      width: 88vw;\n      min-height: 360px;\n      padding-bottom: 45px;\n      background-color: var(--content-container-background);\n      display: flex;\n      flex-grow: 1;\n      .lhs-input-column-one {\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n\n        .wrapper {\n          position: absolute;\n          display: flex;\n          flex-direction: column;\n          width: 100%;\n          border: 1px solid var(--input-field-border-color);\n          border-radius: 4px;\n          background-color: var(--input-field-color);\n          color: var(--input-text-color);\n          font-size: 12px;\n          font-family: Arial;\n          z-index: 0;\n          .dYrfwz {\n            padding-left: 8px;\n            min-height: 32px;\n            width: 100%;\n            display: flex;\n            -webkit-box-align: center;\n            align-items: center;\n          }\n        }\n        .wrapper:focus {\n          outline: none;\n          border-color: none;\n        }\n        .input-field {\n          padding: 12px;\n          align-items: center;\n          gap: 8px;\n          flex: 1 0 0;\n          width: 372px;\n          height: 13px;\n          border-radius: 6px;\n          gap: 4px;\n          border: 1px solid #dbdbdb;\n          margin-bottom: 6px;\n          margin-top: 4px;\n        }\n        .input-field:focus {\n          outline: none;\n          border-color: none;\n        }\n      }\n      .rhs-text-area-container-and-btn-group {\n        display: flex;\n        flex-direction: column;\n        margin-right: 30px;\n        gap: 2px;\n        margin-top: 70px;\n        .application {\n          margin-top: 33px;\n        }\n        .input-field {\n          padding: 12px;\n          align-items: center;\n          gap: 8px;\n          flex: 1 0 0;\n          width: 372px;\n          height: 13px;\n          border-radius: 6px;\n          gap: 4px;\n          border: 1px solid #cacaca;\n          margin-bottom: 6px;\n          margin-top: 4px;\n        }\n        .input-field:focus {\n          outline: none;\n          border-color: #2a35ff;\n        }\n      }\n      .userNotFound {\n        display: block;\n        color: red;\n      }\n      .userFound {\n        display: none;\n      }\n      label {\n        color: var(--label-color);\n        font-family: ABBvoice-Regular;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 150%;\n        margin-bottom: 2px;\n      }\n      .select {\n        display: flex;\n        padding: 10px;\n        align-items: center;\n        gap: 8px;\n        flex: 1 0 0;\n        width: 400px;\n        height: 41px;\n        border: 1px solid #cacaca;\n        border-radius: 5px;\n        font-size: 14px;\n        option {\n          display: flex;\n          height: 16px;\n          flex-direction: column;\n          justify-content: center;\n          flex: 1 0 0;\n          overflow: auto;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n          font-family: ABBvoice;\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 400;\n          line-height: 115%;\n        }\n      }\n      .select:focus {\n        border: 1px solid #36f;\n      }\n      .select::selection {\n        border: 1px solid #36f;\n      }\n      .lhs-input-column-one {\n        margin: 31px 31px 31px 18px;\n        min-width: 25vw;\n        display: flex;\n        justify-content: flex-start;\n        gap: 10px;\n        .assign-role-input {\n          display: flex;\n          height: 34px;\n          .autosearch {\n            width: 240px;\n            z-index: 10;\n          }\n          .ABB_CommonUX_Dropdown__comp {\n            width: 240px;\n          }\n          label {\n            display: flex;\n            min-width: 114px;\n            align-items: center;\n          }\n          .css-15g569d-control {\n            border: 1px solid var(--input-field-border-color) !important;\n            background-color: var(--input-field-color) !important;\n          }\n        }\n        .role {\n          margin-bottom: auto;\n          margin-left: 1px;\n        }\n      }\n      .togged-roles {\n        margin-top: 30px;\n        margin-bottom: 10px;\n        .togged-role-text {\n          color: #1f1f1f;\n          font-family: \"ABBvoice\";\n          font-size: 12px;\n          font-style: normal;\n          font-weight: 600;\n          line-height: 150%;\n          margin-bottom: 10px;\n        }\n        .card-container {\n          display: flex;\n          flex-wrap: wrap;\n          overflow-y: auto;\n          width: 54vw;\n          flex-shrink: 0;\n          margin-top: -14px;\n          margin-left: -6px;\n          .role-card {\n            font-family: \"ABBvoice\";\n            background-color: #ebebeb;\n            font-size: 14px;\n            font-style: normal;\n            height: fit-content;\n            padding: 3px;\n            margin: 10px 10px 10px 6px;\n            padding-left: 10px;\n            border-radius: 16px;\n            font-weight: 400;\n            line-height: 20px; /* 142.857% */\n            span {\n              margin-right: 5px;\n              font-size: 12px;\n            }\n            button {\n              background: none;\n              border: none;\n              cursor: pointer;\n              margin-left: 5px;\n            }\n          }\n        }\n      }\n      .togged-user-new-roles {\n        margin-top: 40px;\n        margin-bottom: 10px;\n        .togged-role-text {\n          color: #1f1f1f;\n          font-family: \"ABBvoice\";\n          font-size: 12px;\n          font-style: normal;\n          font-weight: 600;\n          line-height: 150%;\n          margin-bottom: 10px;\n        }\n        .card-container {\n          display: flex;\n          flex-wrap: wrap;\n          overflow-y: auto;\n          width: 54vw;\n          flex-shrink: 0;\n          margin-top: -14px;\n          margin-left: -6px;\n          .role-card {\n            font-family: \"ABBvoice\";\n            background-color: #ebebeb;\n            font-size: 14px;\n            font-style: normal;\n            height: fit-content;\n            padding: 3px;\n            margin: 10px 10px 10px 6px;\n            padding-left: 10px;\n            border-radius: 16px;\n            font-weight: 400;\n            line-height: 20px; /* 142.857% */\n            span {\n              margin-right: 5px;\n              font-size: 12px;\n            }\n            button {\n              background: none;\n              border: none;\n              cursor: pointer;\n              margin-left: 5px;\n            }\n          }\n        }\n      }\n    }\n    .ABB_CommonUX_Button__root.ABB_CommonUX_Button__mediumSize\n      > div\n      > span.ABB_CommonUX_Button__icon,\n    .ABB_CommonUX_Button__root.ABB_CommonUX_Button__mediumSize\n      > div\n      > span.ABB_CommonUX_Button__loadingIndicator {\n      height: 15px;\n      left: 10px;\n      top: 11px;\n      width: 16px;\n    }\n  }\n  .flex-justify-end {\n    display: flex;\n    justify-content: end;\n    padding: 0px 20px 20px 0px;\n  }\n  .jiMOeR .wrapper:focus-within {\n    box-shadow: none !important;\n  }\n}\n\n.ABB_CommonUX_Input__root > .ABB_CommonUX_Input__inputWrapper {\n  border-color: #dbdbdb !important;\n  border-radius: 4px !important;\n  border-width: 2px !important;\n}\n.css-15g569d-control {\n  width: 100%;\n  height: 34px !important;\n  border: 2px solid #dbdbdb !important;\n  border-radius: 4px !important;\n}\n.css-1xr93k-control {\n  border-radius: 4px !important;\n  border-color: none !important;\n}\n.css-1xr93k-control :hover {\n  background: var(--dropdown-background-color-hover) !important;\n}\n.dYrfwz > input {\n  width: 100%;\n  padding: 0px 0px 0px 13px;\n  border: none;\n  outline: none;\n  background-color: rgba(0, 0, 0, 0);\n  font-size: 14px !important;\n  font-family: \"ABBvoice\" !important;\n  color: var(--input-text-color);\n}\n.gap-30 {\n  gap: 30px !important;\n}\n.gap-20 {\n  gap: 20px !important;\n}\n.gap-40 {\n  gap: 40px !important;\n}\n\n.css-ht7ws5 {\n  color: var(--input-text-color)!important;\n  height: 16px;\n  line-height: 16px;\n  width: 0;\n  margin-top: 1px;\n  grid-row: 1;\n  grid-column: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
